import React from "react"
import ThreeColumnLayout from "~layouts/ThreeColumnLayout"

import * as style from "./Centered.module.scss"

const Centered = ({
  children, wide, mid, id,
}) => {
  let alignment = ""

  switch (alignment) {
    case wide:
      alignment = "wide"
      break
    case mid:
      alignment = "mid"
      break
    default:
      alignment = "narrow"
  }

  return (
    <div id={id} className={style.centered}>
      <ThreeColumnLayout alignment={alignment}>
        <></>
        <>{children}</>
        <></>
      </ThreeColumnLayout>
    </div>
  )
}

export default Centered
